var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFdic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.7 6H0V0H52.8",
    transform: "translate(6.19238 70.8)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22.2V5H1.9",
    transform: "translate(58.9922 70.8)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2049 3.4L73.6049 27.8H6.80488L40.2049 3.4ZM40.2049 0C39.9049 0 39.6049 0.1 39.4049 0.3L0.504879 28.7C-0.495121 29.4 0.104879 30.8 1.30488 30.8H79.2049C80.4049 30.8 80.9049 29.4 80.0049 28.7L41.0049 0.3C40.8049 0.1 40.5049 0 40.2049 0Z",
    transform: "translate(0.987305)",
    fill: "#007EE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V39.2",
    transform: "translate(9.79199 30.8)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V39.2",
    transform: "translate(16.1919 30.8)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V39.2",
    transform: "translate(28.0923 30.8)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V39.2",
    transform: "translate(34.5923 30.8)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V39.2",
    transform: "translate(46.4922 30.8)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V39.2",
    transform: "translate(52.8921 30.8)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V39.2",
    transform: "translate(64.792 30.8)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V39.2",
    transform: "translate(71.1919 30.8)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 45.5C3 35.9 0.4 19.2 0 12.4C0 12 0.200002 11.7 0.600002 11.7C8.2 11 14.6 6.8 17.8 0.399998C18 0.0999977 18.3 0 18.4 0C18.6 0 18.8 0.0999977 19 0.399998C22.2 6.8 28.6 11 36.2 11.7C36.6 11.7 36.9 12 36.8 12.4C36.4 19.2 33.8 35.9 18.4 45.5Z",
    transform: "translate(52.792 42.9)",
    fill: "url(#paint0_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0076 3.9C23.5076 9.8 29.7076 13.7 36.9076 14.6C36.4076 21.5 33.6076 36.3 20.0076 45.2C6.50759 36.2 3.70759 21.4 3.20759 14.5C10.4076 13.7 16.5076 9.7 20.0076 3.9ZM20.0076 0C19.2076 0 18.5076 0.400001 18.0076 1.2C15.1076 7.1 9.10759 11 2.00759 11.6C0.80759 11.7 -0.0924101 12.7 0.00758988 13.9C0.40759 20.2 2.90759 38.6 19.9076 48.7C36.9076 38.7 39.4076 20.3 39.8076 13.9C39.9076 12.7 39.0076 11.7 37.8076 11.6C30.7076 11 24.8076 7 21.8076 1.2C21.6076 0.400001 20.8076 0 20.0076 0Z",
    transform: "translate(51.1846 41.5)",
    fill: "#FBAC1F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-12.8921 63.8661) scale(62.6259) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdic);
export default __webpack_public_path__ + "static/media/fdic.f8319d0d58e30e33d4af024a179aa37b.svg";
export { ForwardRef as ReactComponent };